module.exports = __webpack_public_path__ + "static/media/logov2_tr.269ed3bd.png";